<template>
  <NewLayout v-if="showNewHome" />
  <GeneralLayout v-else />
</template>

<script>
import NewLayout from "./NewLayout.vue";
import GeneralLayout from "./GeneralLayout.vue";
import { isMac, isWindows, isIOS, isAndroid, isLinux } from "@/helpers/getOs";
import { mapGetters } from "vuex";

export default {
  components: {
    GeneralLayout,
    NewLayout,
  },
  computed: {
    ...mapGetters(["IS_SHOW_NEW_HOME_MAC", "IS_SHOW_NEW_HOME_WINDOWS", "IS_SHOW_NEW_HOME_LINUX", "IS_SHOW_NEW_HOME_ANDROID", "IS_SHOW_NEW_HOME_IOS"]),
    showNewHome() {
      if (isMac()) return (this.$route.path === "/" && this.IS_SHOW_NEW_HOME_MAC)
      if (isWindows()) return (this.$route.path === "/" && this.IS_SHOW_NEW_HOME_WINDOWS)
      if (isLinux()) return (this.$route.path === "/" && this.IS_SHOW_NEW_HOME_LINUX)
      if (isAndroid()) return (this.$route.path === "/" && this.IS_SHOW_NEW_HOME_ANDROID)
      if (isIOS()) return (this.$route.path === "/" && this.IS_SHOW_NEW_HOME_IOS)
      return false
    }
  },
};
</script>
